<template>
    <div class="manage-module">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" success-text="刷新成功">
            <div class="store-box flex-start flex-y-center" v-if="regionPostId.includes(postId)">
                <div @click="openRegionPopup" class="region-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedRegion.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
                <div v-if="checkedStore.id != -1" @click="openRegionStorePopup" class="store-name-box flex-row flex-between flex-y-center">
                    <div class="name-txt">{{ checkedStore.name }}</div>
                    <img class="store-arrow" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/node/home-right-arrow.png" alt="">
                </div>
            </div>
            <div class="change-store" @click.stop="selectPopup" v-if="!regionPostId.includes(postId)">
                <div class="fl">{{ checkedOldStore.name }}</div>
                <img class="change-store-icon fl" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/manage/right-arrow.png" alt="">
            </div>
            <div class="change-box flex-y-center flex-between">
                <div class="change-time-box flex-1 flex-start flex-y-center" @click.stop="selectTimePopup">
                    <img class="change-time-icon fl" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/manage/date-icon.png" alt="">
                    <div class="change-time">{{ confirmFormattedDate }}</div>
                    <img class="change-time-arrow fl" v-if="!isYearTab" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/manage/down-arrow.png" alt="">
                </div>
                <div class="change-year-tab flex-y-center">
                    <div :class="`change-year-item  ${!isYearTab ? 'active' : ''}`" @click="clickYearTab(1)">月数据</div>
                    <div :class="`change-year-item  ${isYearTab ? 'active' : ''}`" @click="clickYearTab(2)">年数据</div>
                </div>
            </div>

            <div class="briefing-box flex-between flex-y-center">
                <div class="briefing-title flex-1 flex-y-center">客户贡献<span class="Greys font26 margin-left-sm">(万元）</span></div>
                <div class="briefing-title-time">{{ businessData.date }}</div>
            </div>
            <div class="chunk-box flex-y-center flex-between">
                <div class="chunk" @click="toCustomerContribution('recharge')">
                    <div class="chunk-tit">权益金</div>
                    <div class="chunk-num">{{ businessData.accountAmt }}</div>
                    <img class="chunk-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/manage/equity.png" alt="">
                </div>
                <div class="chunk" @click="toCustomerContribution('consume')">
                    <div class="chunk-tit">净消费</div>
                    <div class="chunk-num">{{ businessData.sumAmt }}</div>
                    <img class="chunk-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/manage/net-cosume.png" alt="">
                </div>
            </div>
            <div class="briefing-box flex-between flex-y-center">
                <div class="briefing-title flex-1 flex-y-center">重点护理项目<span class="Greys font26 margin-left-sm">(万元）</span></div>
                <div class="briefing-title-time">{{ businessData.date }}</div>
            </div>
            <div class="chunk-box flex-y-center flex-between" @click="toEmphasisNursing">
                <div class="chunk">
                    <div class="chunk-tit">销售金额</div>
                    <div class="chunk-num">{{ businessData.saleAmt }}</div>
                    <img class="chunk-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/manage/sale.png" alt="">
                </div>
                <div class="chunk">
                    <div class="chunk-tit">消费金额</div>
                    <div class="chunk-num">{{ businessData.netAmt }}</div>
                    <img class="chunk-icon" src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/manage/consume.png" alt="">
                </div>
            </div>
            <div class="briefing-box flex-between flex-y-center">
                <div class="briefing-title flex-1">客流分布</div>
            </div>
            <div class="change-tab flex-y-center flex-between">
                <div :class="`change-tab-item ${tabIndex == 1 ? 'active' : ''}`" @click="clickTab(1)">未来14天客流分布</div>
                <div :class="`change-tab-item ${tabIndex == 2 ? 'active' : ''}`" @click="clickTab(2)">未来客流专属分布</div>
            </div>
            <div class="unit">单位：人</div>
            <div class="passenger-chart" v-show="tabIndex == 1">
                <div ref="passengerchart" id="passengerchart"></div>
            </div>
            <div class="exclusive-chart" v-show="tabIndex == 2">
                <div ref="exclusivechart" id="exclusivechart"></div>
            </div>
            <div class="statistics-list flex-y-center">
                <div class="v3-box flex-col flex-1">
                    <span class="v3-name">总统计</span>
                    <span class="v3-data">{{ passengerFlowData.totalNumber }}</span>
                </div>
                <div class="split-line"></div>
                <div class="v3-box flex-col flex-1">
                    <span class="v3-name">本店</span>
                    <span class="v3-data">{{ passengerFlowData.storeNumber }}</span>
                </div>
                <div class="split-line"></div>
                <div class="high-box flex-col flex-1">
                    <span class="high-name">异店</span>
                    <span class="high-data">{{ passengerFlowData.otherNumber }}</span>
                </div>
                <div class="split-line"></div>
                <div class="potential-box flex-col flex-1">
                    <span class="potential-name">散客</span>
                    <span class="potential-data">{{ passengerFlowData.newCustomerNumber }}</span>
                </div>
            </div>
            <div class="briefing-box flex-between flex-y-center" style="margin-bottom:20px">
                <div class="briefing-title flex-1">本月二次预约分布</div>
            </div>
            <div class="unit" style="margin:0">单位：人</div>
            <div class="head-chart">
                <div ref="headchart" id="headchart"></div>
            </div>
        </van-pull-refresh>
        <van-popup v-model="showPopup" round position="bottom" closeable class="popup">
            <picker title="更换门店" v-model="checkedOldStore" :list="storeList" @change="onChange"></picker>
        </van-popup>
        <van-popup v-model="showTimePopup" round position="bottom" class="popup">
            <van-datetime-picker v-model="currentDate" type="year-month" title="选择年月" :min-date="minDate" :max-date="maxDate" @confirm='confirm' @cancel="onCancel" />
        </van-popup>
        <!-- 区经区总 切换区域 -->
        <van-popup v-model="showRegionPopup" round position="bottom" closeable class="popup">
            <picker title="选择区域" v-model="checkedRegion" :list="regionList" @change="onRegionChange"></picker>
        </van-popup>
        <!-- 区经区总 切换门店 -->
        <van-popup v-model="showRegionStorePopup" round position="bottom" closeable class="popup">
            <picker title="选择门店" v-model="checkedStore" :list="regionStoreList" @change="onRegionStoreChange"></picker>
        </van-popup>
    </div>

</template>
<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import Picker from '@/components/Picker';
    import { padZero } from '../toDo/utils'
    import { keepAliveAfterHandler } from "@/router/router";
    import { setCookie, base64Decode } from '@/utils'
    import { getUserLogin, getRegionStoreList, saveRegionStore } from '@/api/home'
    import { mapState } from 'vuex'
    import { getCookie } from '@/utils'


    export default {
        name: "manageHome",
        inject: ['reload'],
        components: { Picker },
        data() {
            return {
                loading: false,
                finished: false,
                refreshing: false,
                yearTabIndex: 1, // 年或者月tab
                tabIndex: 1, // 客流tab
                passengerFlowData: {},// 客流数据
                showPopup: false,
                showTimePopup: false,
                checkedOldStore: { // 主任等切换门店
                    id: 0,
                    name: ''
                },
                storeList: [],// 门店列表
                reBookingData: {}, // 二次预约数据
                businessData: {}, // 客户贡献
                minDate: new Date(1949, 0, 1),
                maxDate: new Date(2035, 10, 1),
                currentDate: null,
                confirmDate: new Date(), // 默认当月
                lineChart: null,
                pieChart: null,
                columnChart: null,
                storeId: 0,
                isRegion: false, //是否是区域
                postId: 0, // 岗位
                showRegionPopup: false,
                showRegionStorePopup: false,
                regionStoreList: [],//区域门店列表
                regionList: [],//区域列表
                checkedRegion: { id: -1, name: '' },//所选区域
                checkedStore: {  //所选门店
                    name: '',
                    id: -1,
                },
            };
        },
        // beforeRouteLeave(to, from, next) {
        //     keepAliveAfterHandler.call(this, to, from)
        //     next()
        // },
        computed: {
            confirmFormattedDate() {
                return this.isYearTab ? this.formatYearTime(this.confirmDate) : this.formatTime(this.confirmDate)
            },
            isYearTab() {
                return this.yearTabIndex === 2
            },
            ...mapState({
                regionPostId: (state) => {
                    return state.user.permissions.regionPostId
                },// 区经区总id
            }),
        },
        mounted() {
            this.postId = getCookie('postId') || localStorage.getItem('postId');
            this.init()
            window.onresize = () => {
                this.lineChart && this.lineChart.resize()
                this.pieChart && this.pieChart.resize()
                this.columnChart && this.columnChart.resize()
            }
        },
        methods: {
            init() {
                // 获取当前登陆人所记录的区域门店信息
                getUserLogin().then((res) => {
                    if (this.regionPostId.includes(this.postId)) {
                        this.checkedRegion.name = res.data.region?.storeName // 当前区域
                        this.checkedRegion.id = res.data.region?.id
                        if (res.data.store) {
                            this.checkedStore.name = res.data.store.storeName //当前门店
                            this.checkedStore.id = res.data.store.id
                            // 门店列表
                            let params = {
                                id: this.checkedRegion.id
                            }
                            getRegionStoreList(params).then((res) => {
                                this.regionStoreList = res.data
                            })
                        }
                        // 区域列表
                        getRegionStoreList().then((res) => {
                            this.regionList = res.data
                        })
                    }
                    this.getEmployeeEnableStore()
                    this.getStoreList()
                })
            },
            // 获取当前门店
            getEmployeeEnableStore() {
                request({
                    url: '/employeeStore/getEmployeeEnableStore',
                    method: "get",
                })
                    .then((res) => {
                        this.checkedOldStore.name = res.data.storeName
                        this.checkedOldStore.id = res.data.id
                        this.storeId = res.data.storeId
                        this.isRegion = res.data.isRegion
                        this.initTwiceChart()
                        this.getBusinessData()
                        if (this.tabIndex == 1) {
                            this.initPassengerChart()
                        } else if (this.tabIndex == 2) {
                            this.initExclusiveChart()
                        }
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 客户贡献
            getBusinessData() {
                let params = {
                    type: this.yearTabIndex,
                    date: this.confirmFormattedDate,
                    storeId: this.storeId
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                return request({
                    url: `/business/businessData`,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.businessData = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 客流数据
            getPassengerFlowData() {
                let params = {
                    type: this.tabIndex,
                    storeId: this.storeId
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                return request({
                    url: `/business/passengerFlow`,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.passengerFlowData = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 二次预约
            getReBooking() {
                let params = {
                    storeId: this.storeId
                }
                if (this.regionPostId.includes(this.postId)) {
                    params.id = this.checkedRegion.id
                    params.storeId = this.checkedStore.id
                }
                return request({
                    url: `/business/reBooking`,
                    method: "get",
                    params: params
                })
                    .then((res) => {
                        this.reBookingData = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 去重点护理
            toEmphasisNursing() {
                if (!this.isRegion) {
                    this.$router.push({ name: "emphasisNursing", query: { date: this.confirmFormattedDate, type: this.yearTabIndex } });
                }
            },
            // 去客户贡献
            toCustomerContribution(tabType) {
                if (!this.isRegion) {
                    this.$router.push({ name: "customerContribution", query: { date: this.confirmFormattedDate, type: this.yearTabIndex, tabType: tabType } });
                }
            },
            // tab事件
            clickYearTab(tabIndex) {
                this.yearTabIndex = tabIndex
                this.getBusinessData()
            },
            clickTab(tabIndex) {
                this.tabIndex = tabIndex
                if (tabIndex == 2) {
                    this.$nextTick(() => { this.initExclusiveChart() })
                }
            },
            //更换门店
            selectPopup() {
                this.showPopup = true
            },
            onChange(data) {
                this.checkedOldStore = data
                let params = {
                    id: this.checkedOldStore.id
                }
                request({
                    url: '/employeeStore/updateEmployeeStore',
                    method: "post",
                    data: params
                })
                    .then((res) => {
                        let token = JSON.parse(base64Decode(res.data)).data.token
                        setCookie("token", token);
                        this.showPopup = false
                        // this.reload()
                        location.reload()
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 更换时间
            selectTimePopup() {
                this.currentDate = this.confirmDate
                if (!this.isYearTab) {
                    this.showTimePopup = true
                }
            },
            confirm(e) {
                this.confirmDate = e
                this.showTimePopup = false
                this.getBusinessData()
            },
            // 取消
            onCancel() {
                this.showTimePopup = false
            },
            // 时间格式化
            formatTime(e) {
                var d = new Date(e);
                var datetime = d.getFullYear() + "年" + padZero(d.getMonth() + 1, 2) + '月'
                return datetime;
            },
            formatYearTime(e) {
                return new Date(e).getFullYear() + "年"
            },
            // 获取门店列表
            getStoreList() {
                request({
                    url: '/employeeStore/getEmployeeAllStore',
                    method: "get",
                })
                    .then((res) => {
                        this.storeList = res.data
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    })
            },
            // 刷新
            onRefresh() {
                // 清空列表数据
                this.finished = false;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.refreshing = false;
                this.init()
            },
            // 折线图
            async initPassengerChart() {
                this.getPassengerFlowData().then(() => {
                    // 基于准备好的dom，初始化echarts实例
                    this.lineChart = this.$echarts.init(this.$refs.passengerchart);

                    let option = {
                        backgroundColor: "#fff",
                        tooltip: {
                            trigger: "axis",
                            show: true,
                        },
                        legend: {
                            show: false,
                        },
                        grid: {
                            left: "0",
                            right: "3%",
                            top: "10%",
                            bottom: "0",
                            containLabel: true,
                        },
                        xAxis: {
                            axisLine: {
                                show: true,
                            },
                            axisTick: {
                                show: false,
                            },
                            axisLabel: {
                                interval: 0,
                                textStyle: {
                                    color: '#35434C'
                                }
                            },
                            data: this.passengerFlowData.axisTitleList,
                        },
                        yAxis: {
                            splitNumber: 5,
                            splitLine: {
                                lineStyle: {
                                    type: 'dashed' // y轴分割线类型
                                }
                            },
                            axisTick: {
                                show: false,
                            },
                            axisLabel: {
                                textStyle: {
                                    color: '#35434C'
                                }
                            },
                        },
                        series: [
                            {
                                name: "",
                                type: "line",
                                smooth: true,
                                symbolSize: 6,
                                lineStyle: {
                                    normal: {
                                        width: 2,
                                        color: "#5267F8",
                                    },
                                },
                                label: {
                                    color: "#5267F8",
                                    show: true // 在折线拐点上显示数据
                                },
                                itemStyle: {
                                    color: "#5267F8",
                                    borderWidth: 2,
                                },

                                data: this.passengerFlowData.numberList,
                            },
                        ],
                    };
                    this.lineChart.setOption(option);
                });
            },
            //饼图加载
            async initTwiceChart() {
                const _this = this

                this.getReBooking().then(() => {
                    // 基于准备好的dom，初始化echarts实例
                    this.pieChart = this.$echarts.init(this.$refs.headchart);
                    let options = {
                        title: {
                            text:
                                "{b|二次预约率}" +
                                "{d|\n" +
                                this.reBookingData.reBookingRate +
                                "%}" + "{c|\n(}" + "{c|" + this.reBookingData.reBookingNumber + "}" + "{c|/}" + "{c|" + this.reBookingData.monthOrderNumber + "}" + "{c|)}"
                            ,
                            x: "center",
                            y: "center",
                            top: '36%',
                            textStyle: {
                                rich: {
                                    b: {
                                        fontSize: (window.innerWidth * 22) / 750,
                                        color: "#66757F",
                                        padding: [0, 0, 10, 0],
                                    },
                                    c: {
                                        fontSize: (window.innerWidth * 22) / 750,
                                        color: "#35434C",
                                    },
                                    d: {
                                        fontSize: (window.innerWidth * 46) / 750,
                                        color: "#35434C",
                                        padding: [0, 0, 10, 0],
                                        fontWeight: "bold",
                                    },
                                },
                            },
                        },
                        series: [
                            {
                                type: 'pie',
                                radius: ['38%', '65%'],
                                center: ["50%", "45%"],
                                // avoidLabelOverlap: false,  //备注隐藏
                                label: {
                                    show: true,
                                    // color: "#35434C",
                                    rich: {
                                        c: {
                                            padding: [6, 0, 0, 0],
                                            fontSize: window.innerWidth * 26 / 750,
                                            color: "#35434C",
                                            align: 'left',
                                        },
                                    },
                                },
                                labelLine:
                                {
                                    normal: {
                                        length: 20,
                                        length2: 16,
                                        lineStyle: {
                                            width: 2//设置线条粗细
                                        }
                                    }
                                },
                                data: [
                                    { value: this.reBookingData.newCustomerNumber, name: '{c|散客 \n' + this.reBookingData.newCustomerNumber + '}', itemStyle: { color: '#6FA4F8' }, },
                                    { value: this.reBookingData.otherNumber, name: '{c|异店 \n' + this.reBookingData.otherNumber + '}', itemStyle: { color: '#BDD4F9' } },
                                    { value: this.reBookingData.storeNumber, name: '{c|本店 \n' + + this.reBookingData.storeNumber + '}', itemStyle: { color: '#3677E0' } },
                                ]
                            }
                        ]
                    };

                    this.pieChart.setOption(options);
                });

            },
            //柱状图加载
            async initExclusiveChart() {
                const _this = this
                this.getPassengerFlowData().then(() => {
                    // 基于准备好的dom，初始化echarts实例
                    var dataAll = [389, 259, 262, 324, 232, 176, 196, 214, 133, 370];
                    var yAxisData = this.passengerFlowData.axisTitleList;
                    this.columnChart = this.$echarts.init(this.$refs.exclusivechart);
                    let options = {
                        grid: {
                            top: "5%",
                            left: "2%",
                            bottom: "3%",
                            right: "6%",
                            containLabel: true,
                        },
                        tooltip: {
                            borderColor: 'transparent',
                            formatter: "{b} ({c})",
                        },
                        xAxis: [
                            {
                                gridIndex: 0,
                                axisTick: {
                                    show: false,
                                },
                                axisLabel: {
                                    show: true
                                },
                                splitLine: {
                                    show: false
                                },
                                axisLine: {
                                    show: false
                                },
                            },
                        ],
                        yAxis: [
                            {
                                gridIndex: 0,
                                interval: 0,
                                data: yAxisData,
                                axisTick: {
                                    show: true,
                                },
                                axisLabel: {
                                    show: true,
                                    textStyle: {
                                        color: "#35434C",
                                        fontSize: 14
                                    },
                                    formatter: function (yAxisData) {
                                        var strs = yAxisData.split(''); //字符串数组
                                        var str = ''
                                        for (var i = 0, s; s = strs[i++];) { //遍历字符串数组
                                            str += s;
                                            if (!(i % 12)) str += '\n'; //按需要求余
                                        }
                                        return str
                                    }
                                },
                                splitLine: {
                                    show: false,
                                },
                                axisLine: {
                                    show: true,
                                    lineStyle: {
                                        color: "#6E7079",
                                    },
                                },

                            },
                        ],
                        series: [
                            {
                                name: "",
                                type: "bar",
                                xAxisIndex: 0,
                                barWidth: "45%",
                                itemStyle: {
                                    barBorderRadius: 0,
                                    color: '#5267F8',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: "right",
                                        textStyle: {
                                            color: "#5267F8",
                                            fontSize: 16
                                        },
                                    },
                                },
                                data: this.passengerFlowData.numberList,
                            },
                        ],
                    };

                    this.columnChart.setOption(options);
                });

            },
            // 筛选区域门店相关
            openRegionPopup() {
                this.showRegionPopup = true
            },
            onRegionChange(data) {
                this.checkedRegion = data
                this.showRegionPopup = false
                this.$nextTick(() => {
                    // 提交所选区域记录 storeid 覆盖为0给后端判断是区域变更
                    this.checkedStore.id = 0
                    let params = {
                        id: this.checkedRegion.id,
                        storeId: this.checkedStore.id
                    }
                    saveRegionStore(params).then((res) => {
                        // location.reload()
                        this.init()
                    })
                })
            },
            openRegionStorePopup() {
                this.showRegionStorePopup = true
            },
            onRegionStoreChange(data) {
                this.checkedStore = data
                this.showRegionStorePopup = false
                let params = {
                    id: this.checkedRegion.id,
                    storeId: this.checkedStore.id
                }
                saveRegionStore(params).then(() => {
                    // location.reload()
                    this.init()
                })
            },
        },
    };
</script>
<style lang="less" scoped>
    .manage-module {
        height: 100%;
        padding: 40px 30px;
        padding-bottom: 15%;
        overflow-y: auto;

        .change-store {
            min-width: 120px;
            height: 58px;
            padding: 0 16px;
            background: #f5f5f5;
            border-radius: 35px;
            text-align: center;
            line-height: 58px;
            font-size: 26px;
            color: #66757f;
            display: table;
            margin-bottom: 20px;

            .change-store-icon {
                width: 16px;
                height: 26px;
                margin-left: 10px;
                margin-top: 16px;
            }
        }

        .change-box {
            margin-bottom: 47px;

            .change-time {
                color: #66757f;
                font-size: 26px;
                margin-right: 10px;
                margin-left: 20px;
            }

            .change-time-box {
                .change-time-icon {
                    width: 30px;
                    height: 30px;
                }

                .change-time-arrow {
                    width: 26px;
                    height: 16px;
                }
            }

            .change-year-tab {
                width: 300px;
                height: 58px;
                background: #f5f5f5;
                border-radius: 35px;

                .change-year-item {
                    width: 160px;
                    height: 58px;
                    border-radius: 35px;
                    font-size: 28px;
                    text-align: center;
                    color: #a0acb5;
                    line-height: 58px;
                    background: #f5f5f5;
                    z-index: 98;
                }

                .change-year-item.active {
                    color: #ffffff;
                    background: #2fd0d5;
                    z-index: 99;
                }
            }
        }

        .briefing-box {
            margin-bottom: 40px;

            .briefing-img {
                width: 40px;
                height: 40px;
            }

            .briefing-title {
                color: #35434c;
                font-size: 34px;
                font-weight: 700;
            }

            .briefing-title-time {
                font-size: 26px;
                color: #a0acb5;
            }
        }

        .chunk-box {
            .chunk {
                width: 330px;
                height: 161px;
                background: #f7f7f7;
                border-radius: 30px;
                padding: 26px 30px 30px 50px;
                position: relative;
                margin-bottom: 66px;

                .chunk-tit {
                    color: #a5b0b9;
                    font-size: 26px;
                }

                .chunk-num {
                    color: #35434c;
                    font-size: 38px;
                    margin-top: 16px;
                    font-weight: 700;
                }

                .chunk-icon {
                    width: 63px;
                    height: 66px;
                    position: absolute;
                    top: 30px;
                    right: 30px;
                }
            }
        }

        .change-tab {
            width: 444px;
            height: 62px;
            background: #f0f0f0;
            border-radius: 2px;
            padding: 0 2px;

            .change-tab-item {
                width: 218px;
                height: 57px;
                color: #a0acb5;
                font-size: 24px;
                text-align: center;
                border-radius: 2px;
                line-height: 57px;
            }

            .change-tab-item.active {
                width: 218px;
                height: 57px;
                background: #ffffff;
                color: #35434c;
                border-radius: 2px;
                font-weight: 700;
            }
        }

        .unit {
            margin-top: 20px;
            font-size: 26px;
            color: #66757f;
            text-align: right;
        }

        #passengerchart {
            width: 100%;
            height: 380px;
            margin-top: 35px;
        }

        #exclusivechart {
            width: 100%;
            height: 628px;
        }

        .head-chart {
            height: 530px;
        }

        #headchart {
            height: 530px;
        }

        .statistics-list {
            background-color: rgba(250, 250, 254, 1);
            border-radius: 30px;
            height: 158px;
            margin-bottom: 60px;
            margin-top: 50px;

            .v3-box {
                text-align: center;

                .v3-name {
                    height: 37px;
                    font-size: 26px;
                    color: #a5b0b9;
                }

                .v3-data {
                    margin-top: 10px;
                    height: 59px;
                    font-size: 42px;
                    font-weight: 700;
                    color: #35434c;
                }
            }

            .high-box {
                text-align: center;

                .high-name {
                    height: 37px;
                    font-size: 26px;
                    color: #a5b0b9;
                }

                .high-data {
                    margin-top: 10px;
                    height: 59px;
                    font-size: 42px;
                    font-weight: 700;
                    color: #35434c;
                }
            }

            .potential-box {
                text-align: center;

                .potential-name {
                    height: 37px;
                    font-size: 26px;
                    color: #a5b0b9;
                }

                .potential-data {
                    margin-top: 10px;
                    height: 59px;
                    font-size: 42px;
                    font-weight: 700;
                    color: #35434c;
                }
            }

            .basic-box {
                text-align: center;

                .basic-name {
                    height: 37px;
                    font-size: 26px;
                    color: #a5b0b9;
                }

                .basic-data {
                    margin-top: 10px;
                    height: 59px;
                    font-size: 42px;
                    font-weight: 700;
                    color: #35434c;
                }
            }

            .split-line {
                width: 2px;
                height: 58px;
                background: #e9e9e9;
                border-radius: 2px;
            }
        }

        .time-input {
            width: 252px;
            height: 60px;
            background: #f1f1f1;
            border-radius: 4px;
            font-size: 26px;
            font-weight: 400;
            color: #a0acb5;
            line-height: 60px;
            text-align: center;
        }
    }

    .store-box {
        padding-bottom: 30px;
        background-color: #fff;

        .store-arrow {
            width: 16px;
            height: 26px;
            margin-left: 8px;
            margin-top: 3px;
        }

        .region-name-box {
            min-width: 239px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            margin-right: 10px;
            padding: 10px 15px 11px 16px;
        }

        .store-name-box {
            min-width: 187px;
            height: 58px;
            background: #f5f5f5;
            border-radius: 35px;
            padding: 10px 15px 11px 16px;
        }

        .name-txt {
            color: #66757f;
            font-size: 26px;
        }
    }
</style>